var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    {
      staticClass: "main-menu__sublist",
      attrs: { "data-test-id": "submenu-list" },
      on: {
        mouseenter: function($event) {
          return _vm.$emit("tooltipHide")
        }
      }
    },
    _vm._l(_vm.submenuList, function(item, index) {
      return item.visibilityRules
        ? _c(
            "li",
            {
              key: index,
              staticClass: "main-menu__subitem",
              attrs: { "data-test-id": "submenu-list-item" }
            },
            [
              _c(
                "router-link",
                {
                  staticClass: "main-menu__subitem-link",
                  attrs: {
                    to: item.routerLink,
                    "data-test-id": "submenu-list-item-link"
                  }
                },
                [
                  _c(
                    "md-icon",
                    {
                      attrs: {
                        "data-test-id": "submenu-list-item-icon",
                        "md-src": item.icon.includes(".svg") ? item.icon : null
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(!item.icon.includes(".svg") && item.icon) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "main-menu__subitem-text",
                      attrs: { "data-test-id": "submenu-list-item-text" }
                    },
                    [_vm._v("\n        " + _vm._s(item.label) + "\n      ")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-198a8c4f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-198a8c4f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/navigation/mainMenu/submenuList.vue
// module id = sF0+
// module chunks = 1